import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { keyLoading, selectExchangeRates, selectLoading } from './store/slice'
import { getExchangeRatesThunk } from './store/thunk'

let cacheKey = null

const useGetExchangeRates = () => {
  const dispatch = useDispatch()

  const loading = useSelector(selectLoading(keyLoading.EXCHANGE_RATES))
  const exchangeRates = useSelector(selectExchangeRates)

  useEffect(() => {
    if (!cacheKey) {
      cacheKey = true
      dispatch(getExchangeRatesThunk())
    }
  }, [])

  return {
    loading,
    exchangeRates,
  }
}

export default useGetExchangeRates
